
import { Clock, Shield, Users } from 'lucide-react';
import { Link } from 'react-router-dom';

const BenefitsSection = () => {
  return (
    <section className="section-padding bg-white">
      <div className="page-container">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <span className="inline-block px-3 py-1 text-xs font-semibold text-autocare-blue bg-autocare-blue/10 rounded-full mb-4">
              لماذا تختارنا
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-autocare-blue mb-6">فوائد استخدام أوتو كير</h2>
            <p className="text-gray-600 mb-8">
              نحن ملتزمون بجعل صيانة المركبات بسيطة وشفافة وموثوقة لكل مالك سيارة في فلسطين.
            </p>
            
            <div className="space-y-6">
              <div className="flex">
                <div className="flex-shrink-0 mt-1">
                  <div className="bg-autocare-blue/10 p-2 rounded-lg">
                    <Clock className="h-5 w-5 text-autocare-blue" />
                  </div>
                </div>
                <div className="ml-4">
                  <h3 className="text-lg font-semibold mb-1">وفر الوقت</h3>
                  <p className="text-gray-600">اعثر على الزيت المناسب وجدول الخدمة بسرعة دون بحث لا نهاية له.</p>
                </div>
              </div>
              
              <div className="flex">
                <div className="flex-shrink-0 mt-1">
                  <div className="bg-autocare-blue/10 p-2 rounded-lg">
                    <Shield className="h-5 w-5 text-autocare-blue" />
                  </div>
                </div>
                <div className="ml-4">
                  <h3 className="text-lg font-semibold mb-1">ضمان الجودة</h3>
                  <p className="text-gray-600">جميع الورش الشريكة تم فحصها لضمان جودة الخدمة ورضا العملاء.</p>
                </div>
              </div>
            </div>
            
            <div className="mt-8">
              <Link to="/about" className="btn-outline">
                تعرف أكثر عنا
              </Link>
            </div>
          </div>
          
          <div className="relative">
            <div className="relative z-10 rounded-xl overflow-hidden">
              <img alt="صيانة السيارة" className="w-full h-auto rounded-xl" src="https://i.pinimg.com/736x/c1/49/76/c149768dacff8bd6635c630fe52eb0b8.jpg" />
            </div>
            
            <div className="absolute -bottom-6 -left-6 w-2/3 rounded-xl overflow-hidden border-4 border-white shadow-xl z-20">
              
            </div>
            
            <div className="absolute -top-4 -right-4 bg-autocare-yellow p-4 rounded-lg shadow-lg z-30">
              <div className="text-autocare-blue text-center">
                <div className="text-xl font-bold">20+</div>
                <div className="text-sm">شريك خدمة</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;
